import { render, staticRenderFns } from "./download-confirm.vue?vue&type=template&id=0afa559f&scoped=true"
import script from "./download-confirm.vue?vue&type=script&lang=js"
export * from "./download-confirm.vue?vue&type=script&lang=js"
import style0 from "./download-confirm.vue?vue&type=style&index=0&id=0afa559f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa559f",
  null
  
)

export default component.exports